import React from 'react';

/**
 * Shared Suspense fallback for lazy-loaded routes.
 * Same visual pattern as the auth-loading state in ProtectedRoute,
 * so route-level auth checks and chunk loading never look like two
 * separate loading moments.
 */
const RouteLoadingFallback = () => (
    <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        backgroundColor: 'var(--bg-white, #fff)',
    }}>
        <div style={{
            textAlign: 'center',
        }}>
            <div className="spinner" style={{
                width: '48px',
                height: '48px',
                border: '4px solid rgba(99, 102, 241, 0.1)',
                borderTopColor: '#6366f1',
                borderRadius: '50%',
                animation: 'spin 1s linear infinite',
                margin: '0 auto 16px',
            }}></div>
            <p style={{
                fontSize: '16px',
                color: 'var(--text-muted, #666)',
            }}>
                Loading...
            </p>
        </div>
    </div>
);

export default RouteLoadingFallback;
